import styled from 'styled-components';

export const Banner = styled.div`
  background-image: url(${({ src }) => src});
  background-repeat: no-repeat;
  background-position-y: -50px;
  min-height: 260px;
  overflow: hidden;
  font-size: 32px;
  color: #33404D;
  padding: 20px;
  margin-top: -24px;
  margin-left: -24px;
  position: relative;
`;
